import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";

const UserPortalPage = () => {
  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id } = decoded;

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          },
        );

        const data = await resp.json();

        if (resp.ok) {
          setUserAccess(data.access || []);

          if (data.contact_id) {
            localStorage.setItem("contact_id", data.contact_id);
          }

          localStorage.setItem(
            "linked_accounts",
            JSON.stringify(data.linked_accounts || []),
          );
          localStorage.setItem(
            "linked_landlord_accounts",
            JSON.stringify(data.linked_landlord_accounts || []),
          );
          localStorage.setItem(
            "linked_tenant_accounts",
            JSON.stringify(data.linked_tenant_accounts || []),
          );
        } else {
          console.error(
            "Failed to fetch access:",
            data.error || resp.statusText,
          );
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  const handleOwnerPortalClick = () => navigate("/owner-portal");
  const handleTrusteePortalClick = () => navigate("/trustee-portal");
  const handleContractorPortalClick = () => navigate("/contractor-portal");
  const handleRentalOwnerPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "landlord");
    navigate("/rental-portal");
  };

  const handleRentalTenantPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "tenant");
    navigate("/rental-portal");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("contact_id");
    localStorage.removeItem("linked_accounts");
    localStorage.removeItem("linked_landlord_accounts");
    localStorage.removeItem("linked_tenant_accounts");
    navigate("/");
  };

  return (
    <div className={styles.page}>
      <div className={styles.portalFrame}>
        <div className={styles.portalMedia} aria-hidden="true"></div>

        <div className={styles.portalPanel}>
          <div className={styles.formContainer}>
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.portalLogo}
            />
            <h2 className={styles.portalHeading}>USER PORTAL</h2>

            {loadingAccess ? (
              <div className={styles.loadingContainer}>
                <div className={styles.loadingImage}></div>
                <p className={styles.loadingText}>Checking Access...</p>
              </div>
            ) : userAccess.length === 0 ? (
              <p className={styles.errorText}>
                ❌ You do not have access to any portals. Please contact
                support.
              </p>
            ) : (
              <>
                {userAccess.includes("owner") && (
                  <div className={styles.row}>
                    <button
                      className={styles.portalButton}
                      type="button"
                      onClick={handleOwnerPortalClick}
                    >
                      Owner
                    </button>
                  </div>
                )}

                {userAccess.includes("trustee") && (
                  <div className={styles.row}>
                    <button
                      className={styles.portalButton}
                      type="button"
                      onClick={handleTrusteePortalClick}
                    >
                      Trustee
                    </button>
                  </div>
                )}

                {userAccess.includes("contractor") && (
                  <div className={styles.row}>
                    <button
                      className={styles.portalButton}
                      type="button"
                      onClick={handleContractorPortalClick}
                    >
                      Contractor
                    </button>
                  </div>
                )}

                {userAccess.includes("landlord") && (
                  <div className={styles.row}>
                    <button
                      className={styles.portalButton}
                      type="button"
                      onClick={handleRentalOwnerPortalClick}
                    >
                      Landlord
                    </button>
                  </div>
                )}

                {userAccess.includes("tenant") && (
                  <div className={styles.row}>
                    <button
                      className={styles.portalButton}
                      type="button"
                      onClick={handleRentalTenantPortalClick}
                    >
                      Tenant
                    </button>
                  </div>
                )}
              </>
            )}

            <div className={styles.logoutText} onClick={handleLogout}>
              Log out
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPortalPage;
